<template>
  <Modal
    v-if="showNew"
    size="lg"
    confirmText="Skapa bevakning"
    cancelText="Avbryt"
    v-on:confirm="createSubscription()"
    v-on:cancel="$emit('close')"
  >
    <h3 class="text-t4 mb-4">Skapa bevakning</h3>

    <div class="mb-4 flex flex-col gap-2">
      <label  for="selectedObjectType" class="inline-block uppercase text-[14px] tracking-[0.42px] font-bold">Typ av objekt</label>
      <RadioButton
        id="apartment"
        value="apartment"
        label="Bostad"
        name="selectedObjectType"
        v-model="selectedObjectType"
      />
      <RadioButton
        id="studentapartment"
        name="selectedObjectType"
        label="Studentbostad"
        value="studentapartment"
        v-model="selectedObjectType"
      />
      <RadioButton
        id="parking"
        name="selectedObjectType"
        label="Fordonsplats"
        value="parking"
        v-model="selectedObjectType"
      />
      <RadioButton
        id="premise"
        name="selectedObjectType"
        label="Förråd"
        value="premise"
        v-model="selectedObjectType"
      />
    </div>

    <div
      class="flex flex-col gap-4"
      v-if="selectedObjectType == 'apartment' || selectedObjectType == 'studentapartment'"
    >
      <ObjectTypes
        v-if="selectedObjectType == 'apartment'"
        :createForm="true"
        type="RENTALOBJECT_TYPES.APARTMENT"
        v-model="filters.rentalObjectTypes"
        v-bind:activeFilters="filters"
        :type="RENTALOBJECT_TYPES.APARTMENT"
      />
      <TownDistricts v-model="filters.administrativeUnitAreas" />

      <div class="flex flex-col gap-2">
        <label class="inline-block uppercase text-[14px] tracking-[0.42px] font-bold" for="areaMin">Antal rum</label>
        <div class="flex gap-2">
          <Rooms type="min" v-model="filters.minRooms" :max="filters.maxRooms" class="flex-1" />
          <Rooms type="max" v-model="filters.maxRooms" :min="filters.minRooms" class="flex-1" />
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <label class="inline-block uppercase text-[14px] tracking-[0.42px] font-bold" for="roomCountMin">
          Boendeyta (m
          <sup>2</sup>
          )
        </label>
        <div class="flex flex-row gap-2">
          <ObjectArea type="min" v-model="filters.minArea" :max="filters.maxArea" class="flex-1" :activeType="'apartment'"/>
          <ObjectArea type="max" v-model="filters.maxArea" :min="filters.minArea" class="flex-1" :activeType="'apartment'"/>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <label class="inline-block uppercase text-[14px] tracking-[0.42px] font-bold" for="monthRent">Maxhyra</label>
        <Rent v-model="filters.maxRent" :activeType="'apartment'" />
      </div>
    </div>

    <div v-if="selectedObjectType == 'parking'" class="flex flex-col gap-4">
      <div class="flex flex-col gap-2">
        <label for="vehicleType" class="inline-block uppercase text-[14px] tracking-[0.42px] font-bold">Typ av fordon</label>
        <RadioButton
          v-for="item in availableVehicleTypes"
          :key="item.code"
          :id="item.code"
          :value="item.code"
          v-model="selectedVehicle"
          :label="item.caption"
          @change="selectVehicle(item.code)"
        />
      </div>


      <TownDistricts v-model="filters.administrativeUnitAreas" />

      <div class="flex flex-col gap-2">
        <label class="inline-block uppercase text-[14px] tracking-[0.42px] font-bold" for="monthRent">Maxhyra</label>
        <Rent v-model="filters.maxRent" :activeType="'parking'" />
      </div>
    </div>

    <div v-if="selectedObjectType == RENTALOBJECT_TYPES.PREMISE">
      <div class="mb-4 flex flex-col gap-2">
        <label class="text-t6" for="roomCountMin">
          Storlek (m
          <sup>2</sup>
          )
        </label>
        <div class="flex flex-row gap-2">
          <ObjectArea type="min" v-model="filters.minArea" :max="filters.maxArea" class="flex-1" :activeType="'premise'"/>
          <ObjectArea type="max" v-model="filters.maxArea" :min="filters.minArea" class="flex-1" :activeType="'premise'" />
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <label class="inline-block uppercase text-[14px] tracking-[0.42px] font-bold" for="monthRent">Maxhyra</label>
        <Rent v-model="filters.maxRent" :activeType="'premise'" />
      </div>
    </div>
  </Modal>
  <Modal v-if="showCreateSubscriptionModal">
    <CreateSubscription
      :filters="filters"
      :type="selectedObjectType"
      @close="
        showCreateSubscriptionModal = false;
        $emit('close');
      "
      @done="close()"
    />
  </Modal>
</template>

<script>
import Modal from '@/components/ui/modal';
import ObjectTypes from '@/components/search/filters_new/objecttypes';
import TownDistricts from '@/components/search/filters_new/towndistricts';
import Rent from '@/components/search/filters_new/rent';
import Rooms from '@/components/search/filters_new/rooms';
import ObjectArea from '@/components/search/filters_new/area';
import WaitingListType from '@/components/search/filters_new/waitinglisttype';
import Loader from '@/components/ui/loader';
import SubscriptionMixin from '@/mixins/subscription';
import { RENTALOBJECT_TYPES } from '@/config/constants';
import CreateSubscription from '@/components/subscriptions/confirm-subscription';
import RadioButton from '@/components/ui/form/radio';
import Button from '@/components/ui/button';

export default {
  name: 'CreateSubscriptionForm',
  mixins: [SubscriptionMixin],
  components: {
    Modal,
    ObjectTypes,
    TownDistricts,
    Rent,
    Rooms,
    ObjectArea,
    Loader,
    RadioButton,
    Button,
    WaitingListType,
    CreateSubscription,
  },
  props: {
    showNew: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close'],
  data() {
    return {
      showCreateSubscriptionModal: false,
      RENTALOBJECT_TYPES: RENTALOBJECT_TYPES,
      selectedObjectType: 'apartment',
      selectedVehicle: 'CAR',
      availableVehicleTypes: [
        {
          caption: 'Bil',
          code: 'CAR',
        },
        {
          caption: 'Motorcykel',
          code: 'MC',
        },
        {
          caption: 'Båt',
          code: 'BOAT',
        },
      ],
      //  changed:false
    };
  },

  computed: {},

  created() {
    this.filters.rentalObjectTypes = [];
    this.filters.vehicleType = null;
    this.filters.administrativeUnitAreas = [];
    this.filters.maxRent = null;
    this.filters.minArea = null;
    this.filters.minRooms = null;
    this.filters.maxRooms = null;
    this.filters.waitingListType = null;
    this.showLoader = false;
  },
  methods: {
    close() {
      this.$emit('done');
    },

    selectVehicle(itemCode) {
      this.filters.vehicleType = itemCode;
      this.clearRentalObjectTypes();
    },

    clearRentalObjectTypes() {
      this.filters.rentalObjectTypes = [];
    },

    /**
     * Uppdaterar bevakningens inställningar och talar sedan om att den är klar, så formuläret kan stängas.
     */
    createSubscription() {
      setTimeout(() => {
        this.$emit('close');
        this.showCreateSubscriptionModal = true;
      }, 100); // Small delay to avoid keypress propagation
    },
  },
};
</script>
